import { TextField, styled } from "@mui/material";

export const StyledSmallTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputBase-root': {
        height: '35px',
        margin: '5px 0'
    },
}))